No lines are selected.
<template>
  <div id="app">
    <router-view></router-view>

    <footer>
      <div class="tw-container">
        <div class="logos">
            <div>
                <img src="~@/assets/img/logo.svg">
            </div>
        </div>
        <p>Wall Street English © {{new Date().getFullYear()}}</p>
        <p>O Wall Street English é uma cadeia de escolas de Inglês com 35 centros em Portugal e presença no País há mais de 25 anos. Com o objectivo de ensinar Inglês, o Wall Street English diferencia-se dos seus concorrentes pela proposta de valor que apresenta aos seus alunos e pelo seu método de ensino.</p>
      </div>
    </footer>

    <ModalContainer>
      <Terms/>
    </ModalContainer>

    <Clarity/>

    <KwPixel v-if="$store.state.formSuccess"/>
  </div>
</template>

<script>
import axios from 'axios';
import KwPixel from '@/components/KwPixel.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';
import Clarity from '@/components/Clarity.vue';

export default {
    components: {
        KwPixel,
        Clarity,
        ModalContainer,
        Terms,
    },
    created() {
        const data = {
            url: window.location.hostname,
            pubid: this.$route.query.pubid || null,
            utm_source: this.$route.query.utm_source || null,
            utm_campaign: this.$route.query.utm_campaign || null,
            utm_medium: this.$route.query.utm_medium || null,
            utm_content: this.$route.query.utm_content || null,
            utm_term: this.$route.query.utm_term || null,
        };
        axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
            .then((response) => {
                this.$store.state.token = response.data.token;
            })
            .catch((error) => {
                console.log(error.response.data);
            });
    },
    mounted() {
        window.cmp_setlang = document.documentElement.lang;
    },
};
</script>
<style>

</style>
